/* Puzzling Pursuits scroll reveals (31 Aug 2026).
   IntersectionObserver + timed CSS transitions (see section 7 of
   pp-app-widgets.css). Replaces the view()-timeline scrub: iOS Safari
   ignored it, and tall sections spread the scrub over so much scroll that
   nothing appeared to animate. Elements are hidden only after this script
   confirms it will also reveal them, so no-JS and reduced-motion visitors
   always get static content. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var SELECTORS = [
    '.pp-offers',
    '.pp-arch',
    '.pp-seen',
    '.shopify-section--featured-collections .section-stack > *',
    '.shopify-section--featured-collections .product-card',
    '.shopify-section--multi-column .section-stack > *',
    '.shopify-section--newsletter .section-stack > *',
    '.shopify-section--text-with-icons .text-with-icons > *',
    '#shopify-section-template--26581960294673__reviews .section-stack > *'
  ];

  var els = [];
  SELECTORS.forEach(function (sel) {
    document.querySelectorAll(sel).forEach(function (el) {
      if (els.indexOf(el) === -1) els.push(el);
    });
  });

  /* The Loox reviews section has no theme .section-stack - reveal it whole. */
  var reviews = document.getElementById('shopify-section-template--26581960294673__reviews');
  if (reviews && !els.some(function (el) { return reviews.contains(el); })) {
    els.push(reviews);
  }

  /* Leaf-most only: a container holding another target must not also move,
     or cards would ride their wrapper's rise on top of their own. */
  els = els.filter(function (el) {
    return !els.some(function (other) { return other !== el && el.contains(other); });
  });
  if (!els.length) return;

  var parents = [];
  var counts = [];
  els.forEach(function (el) {
    var p = el.parentElement;
    var i = parents.indexOf(p);
    if (i === -1) {
      parents.push(p);
      counts.push(0);
      i = parents.length - 1;
    }
    el.style.setProperty('--pp-reveal-delay', Math.min(counts[i] * 70, 420) + 'ms');
    counts[i] += 1;
    el.classList.add('pp-reveal');
  });

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('pp-in');
        io.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });

  els.forEach(function (el) { io.observe(el); });
})();
